<style src="./ItemRowDocument.scss" lang="scss"></style>
<template>
  <li class="item-row-document">
    <div class="checker">
      <label class="checkbox-label">
        <input
          class="checkbox-input"
          type="checkbox"
          v-model="isChecked">
      </label>
    </div>

    <div class="selection">
      <div
        class="selectall"
        @click="toggleSelectAll">
      </div>
    </div>

    <div class="id">
      <span
        v-if="!!info.lot"
        class="lot">{{ info.lot }}</span>
      <span class="item">{{ info.number }}</span>
    </div>

    <div class="description">
      <span class="value">{{ info.description }}</span>
    </div>

    <div class="labs">
      <span class="value">{{ info.rmsLab }}</span>
      <span class="value">{{ info.quotedLab }}</span>
    </div>

    <div
      @click="openRms"
      :class="{ 'outdated': info.rmsAnvisa && outdatedRms }"
      class="doc">
      <template v-if="haveAnvisa">
        <icon-anvisa-rms v-if="!!info.rmsAnvisa" />
        <span
          v-if="info.rmsAnvisa && outdatedRms"
          class="warning">
          VENCIDO
        </span>
      </template>
    </div>
  </li>
</template>

<script>
import { IconAnvisaRms } from '@/components/primitives/icons'

export default {
  name: 'ItemRowDocument',
  components: {
    IconAnvisaRms
  },
  props: {
    info: {
      default: () => ({})
    },
    eventDate: {
      default: null
    }
  },
  data: () => ({
    isChecked: false
  }),
  watch: {
    'info.isChecked': {
      handler (v) {
        this.isChecked = v
      },
      immediate: true
    },
    isChecked (v) {
      this.$emit('selection', v)
    }
  },
  computed: {
    haveAnvisa () {
      return this.info.rmsAnvisa && this.info.rmsAnvisa.maturityDate
    },
    outdatedRms () {
      const haveAnvisa = this.info.rmsAnvisa && this.info.rmsAnvisa.maturityDate

      const docDate = haveAnvisa && new Date(this.info.rmsAnvisa.maturityDate)
      const eventDate = this.eventDate && new Date(this.eventDate)

      if (!docDate || !eventDate) return true

      return eventDate > docDate
    }
  },
  methods: {
    openRms () {
      const serverUrl = this.$store.getters['Login/SERVER_URL']
      window.open(`${serverUrl}/document/rms/${this.info.rmsAnvisa.documentFile.fileName}`)
    },
    toggleSelectAll () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-rms/components/item-row-document/ItemRowDocument.vue